import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Configure Supabase client with explicit session persistence
// Requirements: 12.1, 12.2 - Store and restore sessions
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use localStorage for persistent sessions across browser sessions
    storage: window.localStorage,
    // Automatically refresh tokens before expiration
    autoRefreshToken: true,
    // Persist session across page reloads
    persistSession: true,
    // Detect session in URL (for OAuth flows)
    detectSessionInUrl: true,
  },
});
